
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/canva-to-googleslides",
      function () {
        return require("private-next-pages/converter/canva-to-googleslides.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/canva-to-googleslides"])
      });
    }
  